// src/components/Widget.js
import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Widget = ({ title, actions, children }) => {
  const theme = useTheme();
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        padding: 2, 
        height: '100%', 
        width: '100%', 
        bgcolor: theme.palette.mode === "dark" ? "rgb(16, 16, 16)" : "background.default",
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
          flexShrink: 0,
          backgroundImage: "none"
        }}
      >
        <Typography variant="h6">{title}</Typography>
        {actions && <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box>}
      </Box>
      <Box 
        sx={{ 
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};

export default Widget;